const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"44bf2669de198e27514ff533f0d9764fc9a21ce7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["property-group@haunt"]={id:"44bf2669de198e27514ff533f0d9764fc9a21ce7"};
      